import { render, staticRenderFns } from "./DamageArchivePopup.vue?vue&type=template&id=12665b86&scoped=true"
import script from "./DamageArchivePopup.vue?vue&type=script&lang=ts"
export * from "./DamageArchivePopup.vue?vue&type=script&lang=ts"
import style0 from "./DamageArchivePopup.vue?vue&type=style&index=0&id=12665b86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12665b86",
  null
  
)

export default component.exports